import {RouteKey} from 'common/src/modules/routing/routing.enums';
import {RouteDef} from 'common/src/modules/routing/routing.types';

function formatRouteDefs(routeDefs: Record<RouteKey, RouteDef>) {
  return Object.entries(routeDefs)
    .map(([routeKey, route]) => {
      let result = `Route Key: ${routeKey}
Display Name: ${route.displayName} 
Path: ${route.path}\n`;

      if (route.pathParams.length === 0) {
        result += 'No path parameters\n';
      } else {
        result += 'Path Parameters:\n';
        result += route.pathParams.map((param) => `- ${_formatPathParam(param)}`).join('\n') + '\n';
      }

      if (route.queryParams.length === 0) {
        result += 'No query parameters';
      } else {
        result += 'Query Parameters:\n';
        result += route.queryParams.map((param) => `- ${_formatQueryParam(param)}`).join('\n');
      }

      return result;
    })
    .join('\n\n');
}

// Example pathParam: {key: 'campaignId', type: 'number', displayName: 'Campaign ID', defaultValue: '12345'}
// This would format to: "campaignId (number, optional)"
function _formatPathParam(param: RouteDef['pathParams'][0]) {
  return `${param.key} (${param.type}, ${param.defaultValue ? 'optional' : 'required'})`;
}

// Example queryParam: {key: 'status', type: 'one of', enumValues: ['active', 'paused', 'archived'], required: false, defaultValue: 'active'}
// This would format to: "status (one of: [active, paused, archived], optional)"
function _formatQueryParam(param: RouteDef['queryParams'][0]) {
  return `${param.key} (${param.type}${param.enumValues ? `: [${param.enumValues.join(', ')}]` : ''}, ${param.required ? 'required' : 'optional'})`;
}

export default formatRouteDefs;
